import { useState } from 'react';
import { UilArrowDown, UilArrowRight } from '@iconscout/react-unicons';
import { Link } from 'react-router-dom';
import ceo from './../../../assets/images/ourteam/CEO.jpg';
import Dorcas from './../../../assets/images/ourteam/dorcas.webp';
import ea from './../../../assets/images/ourteam/_EA.jpg';
import gm from './../../../assets/images/ourteam/_GM.jpg';
import HR from './../../../assets/images/ourteam/hR.webp';
import auditor from './../../../assets/images/ourteam/auditor.webp';
import bami from './../../../assets/images/ourteam/bami.webp';
import allen from './../../../assets/images/ourteam/allen.webp';
import admin2 from './../../../assets/images/ourteam/admin.webp';
import account from './../../../assets/images/ourteam/accountant.webp';

import segun from './../../../assets/images/ourteam/segun.webp';
import jennifer from './../../../assets/images/ourteam/jennifer.webp';
import joy from './../../../assets/images/ourteam/frontdesk.webp';


import hop from './../../../assets/images/ourteam/_HOP.jpg';
import legal from './../../../assets/images/ourteam/Legal1.webp';
import admin from './../../../assets/images/ourteam/_Admin.jpg';
import gracious from './../../../assets/images/ourteam//Gracious.jpg';
import charity from './../../../assets/images/ourteam/Charity.jpg';
import precious from './../../../assets/images/ourteam/Precious.jpg';
import val from './../../../assets/images/ourteam/Val.jpg';
import vivian from './../../../assets/images/ourteam/Vivian.jpg';
import chris from './../../../assets/images/ourteam/Chris.jpg';
import obike from './../../../assets/images/ourteam/Obike.jpg';
import favour from './../../../assets/images/ourteam/Favour1.jpg';
import lagos_branch_mgr from './../../../assets/images/ourteam/lagos_branch_manager.jpg';
import evelyn from './../../../assets/images/ourteam/Evelyn.jpg';
import uwem from './../../../assets/images/ourteam/Uwem.png';



const OurTeam = () => {
  const team = [
    {
      title: 'President/Group CEO',
      description: (() => {
        const fullDescription =
          `I am Paul Smith, a highly accomplished visionary leader, an empathetic entrepreneur, and a technological innovator. With a robust academic foundation that includes a B.Sc. in Business Administration, a B.Sc. in Accounting, and an M.Sc. in both Business Administration and Banking & Financial Support Services, I have built a career over the past two decades that blends strategic insight, empathy, and discipline to drive success across multiple industries.

          My entrepreneurial journey began in 2007, when I took on the role of Managing Director at a Microfinance institution because of my problem-solving and result-driven persona. It was there that I honed my leadership skills, learned the intricacies of business management, and laid the groundwork for my future ventures. By 2012, I had a vision to create something transformative – Smash Group. However, recognizing the importance of continuous growth, I made the strategic decision to refine my abilities further, which led me to become the Management Executive at Business Network Worldwide in 2020. Over the next five years, I gained invaluable expertise in leadership, technology, and entrepreneurship, enriching my experience and expanding my vision.

          Armed with a wealth of knowledge and practical insight, I returned to my initial vision with renewed vigor, relaunching Smash Group as Smash Technology. My focus on integrating cutting-edge technology into daily operations has allowed us to solve real-world problems on both a local and global scale. Today, Smash Technology is a pioneering force, with 13 subsidiaries across industries such as e-hailing, e-commerce, travel, real estate, transportation, and entrepreneur empowerment. Our flagship brands such as RideSmash, SmashWise, SmashTravels, SmashApartments, SmashHire, Qiimeet, SmashBuy, SmashFood247, SmashOffice are driving impactful change across their respective markets.

          As a compassionate leader, I believe in leading with heart and by example. My commitment to integrity, consistency, hard work and empowering my team defines my approach. I strive to create a culture of innovation, collaboration, and growth. With an unwavering dedication to transforming industries and improving lives, I continue to drive Smash Technology toward new heights by delivering excellent and valuable solutions to our esteemed clients locally and globally.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: ceo,
      slug: 'president_grp_ceo',
    },

    // {
    //   title: 'Personal Assistant to The CEO',
    //   description: (() => {
    //     const fullDescription =
    //       `My journey at Smash Technology has been both dynamic and rewarding. As the Personal Assistant to the CEO, I manage the daily flow of executive operations while also playing a key role in coordinating teams, streamlining processes, and ensuring that organizational priorities are met. My work goes beyond administration, it is about enabling leadership to function at its best and creating systems that keep the company moving forward.`;

    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: Dorcas,
    //   slug: 'dorcas_smash',
    // },
    {
      title: 'General Manager',
      description: (() => {
        const fullDescription =
          `I joined Smash Technology with a strong commitment to driving operational excellence, business growth, and strategic leadership across the organization.  I have consistently demonstrated a results-driven mindset, which has translated into measurable revenue growth, enhanced business performance, increased responsibility, and a results-driven mindset.
`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: hop,
      slug: 'grp_biz_operations',
    },
    {
      title: 'Human Resource Manager',
      description: (() => {
        const fullDescription =
          `Since joining Smash Technology Limited as the HR Manager, my journey has been defined by growth, innovation, and transformation. I have had the privilege of building and strengthening the company’s workforce across all areas, ensuring that every department is equipped with the right talent to drive our vision forward.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: HR,
      slug: 'hr_slug',
    },
        
    {
      title: 'Human Resource Assistant',
      description: (() => {
        const fullDescription =
          `I am a Human Resource Assistant at Smash Technology with solid experience in recruitment, onboarding, employee relations, and performance management. Before joining Smash Technology, I had prior experience working as an HR Assistant, which gave me a strong background in people management and organizational processes. I also hold a certificate in Human Resource Management Professionals, which has equipped me with both technical expertise and a practical approach to managing people and systems effectively.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: ea,
      slug: 'hr_asst',
    },
    // {
    //   title: 'Head Legal',
    //   description: (() => {
    //     const fullDescription =
    //       `As Head of Legal & Compliance, I play a significant role in safeguarding the company’s interests while enabling our app-based businesses to scale locally and globally.`;
    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: legal,
    //   slug: 'head_legal',
    // },

    {
      title: 'Auditor',
      description: (() => {
        const fullDescription =
          `With over 14 years of experience as a dually certified professional—a Chartered Accountant and Associate of the Chartered Institute of Personnel Management—I have built a robust career in finance, audit, and risk. My journey began at DAAR Communications Plc, leading to specialized roles in FMCG, lottery, and healthcare.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: auditor,
      slug: 'auditor',
    },
        {
      title: 'Product Manager',
      description: (() => {
        const fullDescription =
          `My name is Mamah Valentine Obumneme, a Lead Designer at Smash Technology, where I have had the privilege of working on a variety of innovative and user-centered products. My passion lies in transforming complex problems into seamless, intuitive designs that enhance user experiences. Over the years, I have honed my skills in areas such as user research, UI/UX design, prototyping, and usability testing, always striving to create solutions that not only look great but also function smoothly.

          At Smash Technology, I have had the opportunity to work on projects that push the boundaries of design, collaborating with talented teams to deliver cutting-edge solutions. My work is deeply rooted in a user-first approach, ensuring that every design decision is made with the user’s needs in mind.

          Working at Smash Technology has been instrumental in shaping my career and expanding my skill set in ways that go beyond design. The company has provided me with invaluable experiences that have allowed me to grow both professionally and personally.
          Being part of cross-functional teams has given me hands-on experience in managing design projects from start to finish. I’ve learned to balance creative goals with business objectives, ensuring that we meet deadlines while delivering high-quality results. Collaborating with developers, project managers, and stakeholders has taught me how to effectively manage resources and keep projects on track.                                                              
          At Smash Technology, I have worked closely with the QA team, helping to ensure that the products we design meet rigorous quality standards. This experience has sharpened my ability to identify potential issues early in the process, iterate quickly, and maintain a focus on user experience throughout the testing phase.

          My role has also involved collaborating with the marketing team to ensure that our product designs align with the brand’s messaging and target audience. Working alongside marketers, I’ve gained a deeper understanding of how design connects with broader market strategies and how to create visually compelling products that resonate with users.

          One of the most rewarding aspects of my time at Smash Technology has been the relationships I’ve built with colleagues across different departments. I’ve had the chance to collaborate closely with engineers, product managers, and other designers, which has helped me improve my communication skills and learn how to integrate various perspectives into my design process.

          These experiences at Smash Technology have allowed me to become a more well-rounded product designer, capable of contributing to projects from multiple angles. I’m grateful for the growth I’ve experienced here, and I continue to strive for excellence in every project I take on. My journey at Smash Technology has not only shaped me as a designer but also as a versatile professional who understands the full scope of what it takes to create successful, user-centered products.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: val,
      slug: 'product_designer',
    },
    //         {
    //   title: 'Head of Creativity',
    //   description: (() => {
    //     const fullDescription =
    //       `From the beginning of my career as a digital marketer, I have been passionate about telling stories that connect brands with their audience. Joining Smash Technology gave me the perfect platform to merge creativity with impact, and for this I am grateful.`;

    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: bami,
    //   slug: 'Creativity',
    // },


                {
      title: 'Group Business Manager',
      description: (() => {
        const fullDescription =
          `I joined Smash Technology with a wealth of experience in FinTech and telecommunications, taking on the role of Business Development Officer. From the very beginning, I was inspired by the organization’s innovative spirit and commitment to excellence. Through dedication, collaboration, and the pursuit of results, my career quickly advanced to the role of Branch Manager of Abuja.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: allen,
      slug: 'Business_Manager',
    },
    // {
    //   title: 'Business Operation Manager, Ridesmash',
    //   description: (() => {
    //     const fullDescription =
    //       `My Name is Favour Jipson.

    //       My Journey with Smash Technology
    //       A graduate of Business Education from Alvan Ikoku Federal University Owerri.
    //       Am Married.

    //       My journey with Smash Technology began on June 6th, 2024, when I join the company as a customer support executive for Ridesmash. At a time, I was still a timid person, and lacking confidence to truly step into a leadership role although still  believing In my self, however, joining Smash Technology quickly changed all of that.

    //       From day one, I was trained to handle customer inquiries with professionalism and poise, handle pressure and stay connected in difficult situation.Although my major work then was to Onboard drivers into our platform. In a short time, I was honored to be promoted to Team Lead for Ridesmash, a role that allowed me to further smothen my leadership skills. The experience of leading a team and over seeing customer operations helped me build my confidence and leadership stature. I went from being someone who doubted myself to becoming a confident and assertive leader, ready to face any challenge that came my way.
    //       There were moments of tough scoldings, moments when I felt like I wasn't good enough but those moments helped shape me into the person I am today. Smash Technology never gave up on me, and their feedback pushed me to be better each day.

    //       Today, I can proudly say that Smash Technology has completely rebranded me. I am no longer the timid person I once was. I am now confident, capable, and assertive. I am grateful for the opportunity to be part of such a remarkable company that has played a huge role in shaping my career and leadership journey.

    //       In the coming future with Smash, I will make sure that our clients get seamless experience with our hire purchase plan by helping them acquire their dream car.
          
    //       All thanks to Smash Technology for believing in me and helping me reach new heights.
    //     `;
    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: favour,
    //   slug: 'team_lead_ridesmash',
    // },

    //             {
    //   title: 'Account Manager',
    //   description: (() => {
    //     const fullDescription =
    //       `Meet Uyo Victor, the accountant of smash technology, I am a Seasoned Accounting Professional and a highly accomplished accountant with degree in accounting and an impressive over 18-year track record of success in the banking, mining, and hospitality sectors.`;

    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: account,
    //   slug: 'accountant',
    // },


    //             {
    //   title: 'Admin Manager',
    //   description: (() => {
    //     const fullDescription =
    //       `My professional journey has been one of growth, resilience, and impact. From starting as a Secretary during my NYSC at the National Assembly, to coordinating large-scale campaigns with CRS, Society for Family Health, and Malaria Consortium, to managing multi-branch operations at Delivery Dot Com, I’ve had the privilege of gaining diverse experiences that shaped my expertise in administration, logistics, procurement, and facility management.`;

    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: admin2,
    //   slug: 'Admin_Manager',
    // },
    // {
    //   title: 'KYC/Case Officer',
    //   description: (() => {
    //     const fullDescription =
    //       `I joined Smash Technology on 5th June, 2024 as a Customer Support Executive. I still laugh when I think about how I came straight from my previous job, dressed in a suit, for the interview. The CEO, a compassionate man, saw something in me and offered me the position.

    //       When I resumed duties on June 6th, 2024, I remember staring at my desktop for two whole days, unsure of what to do next. If you know e-commerce, you understand that setting up a successful platform is no easy feat. I quickly realized that this role was more than just answering customer inquiries – it was about proactively reaching out to vendors and driving results.

    //       The turning point came when the CEO asked for the leads I had generated. That’s when it truly hit me – I needed to focus on vendor acquisition, not just customer support. So, I took it upon myself to learn. I started researching, attending online seminars and absorbing everything I could to improve my skills. With constant encouragement from the CEO, I quickly found my foot.

    //       From starting as a customer support executive to becoming the team lead of Smashwise, it has been a journey of hard work, dedication, and growth. Setting up an e-commerce platform from scratch is challenging, and there were moments when I felt like giving up. But with God’s guidance, the support of our CEO, and the amazing colleagues I have in Charity John and Favour Jipson – who are truly angels sent from above – I pushed through. May God bless you both abundantly. Amen!

    //       I’m proud to share that I single-handedly grew our vendor list from 12 to 200 between June and August, before team members were assigned to me.

    //       Smash Technology has truly transformed me. It has built my confidence, sharpened my intellect and enhanced my leadership skills. I’m still growing, and I’m excited for the future.

    //       Thank you, Smash Technology. Thank you, CEO – you are a blessing sent to me by God.
    //       `;
    //     return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
    //   })(),
    //   image: precious,
    //   slug: 'team_lead_smashwise',
    // },
        {
      title: 'Lead, Software Engineer',
      description: (() => {
        const fullDescription =
          `My name is Omogbehinmi Olusegun E., and my journey as a software engineer has been one of continuous growth, meaningful impact, and transformative experiences, particularly during my time with SmashTechnology.
When I started three years ago, I was passionate about code but still learning how to channel that passion into solutions that truly matter. SmashTechnology became the catalyst that transformed my raw enthusiasm into refined expertise. The company didn't just give me projects; they gave me opportunities to tackle complex challenges, exposed me to cutting-edge technologies, and trusted me to take ownership of solutions that would impact real users and business outcomes.
At SmashTechnology, I've evolved from writing functional code to architecting systems that scale. I've learned to see beyond the immediate problem, to anticipate user needs, design for growth, and build with maintainability in mind. The company's culture of innovation pushed me to explore new technologies and approaches, while their commitment to quality taught me that great code isn't just about what it does, but how elegantly it does it.
My contributions have grown alongside my skills. What began as implementing features has evolved into leading technical decisions, mentoring newer developers, and designing APIs that other teams depend on. I've helped SmashTechnology streamline critical workflows, reduce system complexities, and deliver products that genuinely make users' lives easier. Each project taught me something new, not just about technology, but about translating business needs into technical solutions that create lasting value.
Today, I build tools that cut through complexity, clean APIs, intelligent systems, and seamless experiences that just work. But more than that, I've learned to ask the right questions: What problem are we really solving? Who benefits? How can we make this better tomorrow than it is today?
SmashTechnology shaped me into an engineer who doesn't just solve problems, but solves the right ones, and solves them well. Every line of code I write carries forward the lessons learned, the growth achieved, and the impact we've created together.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: segun,
      slug: 'software_engineer',
    },

//            {
//       title: 'Team Lead, Media',
//       description: (() => {
//         const fullDescription =
//           `My career has always been influenced by my artistic nature, and content creation first began as a personal hobby—a creative outlet I truly enjoyed. That passion turned into a career on February 2025, when I joined Smash Technology as a Content Creator.
// `;

//         return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
//       })(),
//       image: jennifer,
//       slug: 'media',
//     },

//            {
//       title: 'Team Lead, Ridesmash',
//       description: (() => {
//         const fullDescription =
//           `My name is Joy Ekechukwu
 
// My professional journey has always been about growth and new challenges and my arrival at Smash Technology marks an exhilarating new chapter.
// My career journey with Smash Technology started in a role of being the first face of the company to becoming Team Lead for Ride Smash and this promotion came within a month.
// Becoming the Team Lead for Ride Smash came through because the management saw great potentials in me and believe I can take up the role and succeed.
// I was drawn to Smash Technology for it’s forward-thinking approach and commitment to delivering high-impact results for clients globally.
// My time here has been a period of intense learning, warm welcome and a deep dive into the company’s vibrant culture. The Team at Smash Technology has been incredibly supportive.
// I’m eager to expand my skills and collaborate with my team to achieve tangible results.      
//  `;

//         return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
//       })(),
//       image: joy,
//       slug: 'lead_ridesmash',
//     },
    {
      title: 'Brand Designer',
      description: (() => {
        const fullDescription =
          `My name is Christogonus Chiboka. I am a Certified Brand Identity Designer with a strong passion for creativity. My interest in graphic design started when I discovered CorelDRAW. I enjoyed exploring the software and giving myself tasks to create different designs, which sparked my love for design. 

          When I got into school, I started practicing graphic design more seriously. This gave me the chance to improve my skills, especially in brand identity design. I focused on creating unique designs that help brands tell their stories.  
          After finishing school, I joined Smash Technology in September 2024 as a Graphic Designer. I work on designs for all the company’s sub-brands, including RideSmash, Smash Travels, SmashWise, Smash Apartments, and others. At first, it was challenging to meet the design needs of each brand, but with time and practice, I got better at my work and gained confidence in my skills.  

          Working at Smash Technology has also taught me more than just design. I have learned about marketing, teamwork, and other important skills that have helped me grow as a professional.  

          I am passionate about using my designs to bring ideas to life.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: chris,
      slug: 'graphic_designer',
    },
    {
      title: 'Lead IT Support',
      description: (() => {
        const fullDescription =
          `My name is Obike Victor Emeka. Since after my secondary school, my passion for technology and computers only grew stronger. Although I explored other industries, including healthcare, my love for tech remained unwavering. I took a proactive approach to learning, starting with the basics and progressively expanding my skills across various areas, including software and hardware training, coding, computer programming, and graphics design.

          My time in Smash Technology has been a transformative experience, offering invaluable opportunities for growth, learning, and development. Joining as an IT Support Executive, I've had the privilege of collaborating with a talented team of innovative and forward-thinking professionals. This exposure has significantly contributed to my career advancement in tech and has enabled me to enhance my skills and expertise.

          As an IT Support Executive, I encounter a wide range of software and hardware challenges on a daily basis. From familiar issues to novel ones, I leverage my broad IT expertise to provide timely and effective support to my colleagues. I deliver technical assistance, troubleshoot problems, and resolve issues within tight deadlines, all while maintaining workflow efficiency and minimizing downtime.
          
          Smash Technology's commitment to excellence and perfection serves as a powerful motivator for me. I strive to embody this organizational mindset by staying up-to-date with the latest trends and advancements in the tech world. I am dedicated to delivering high-quality results, ensuring that all tasks are completed on time and to the highest standards of perfection.
          
          My aspiration is to continue growing and learning, and I envision a future where I transition into a full-stack mobile app developer role. I am committed to expanding my skill set and expertise to achieve this goal.`;

        return fullDescription.slice(0, 118) + (fullDescription.length > 100 ? '...' : '');
      })(),
      image: obike,
      slug: 'it_support',
    },
  ]; 

  const [visibleProfiles, setVisibleProfiles] = useState(6);

  const handleLoadMore = () => {
    setVisibleProfiles((prev) => prev + 6);
  };

  return (
    <>
    <div className="sections meetourteam max-w-screen-2xl mx-auto" id="ourbusiness">
      <h2 className='text-[32px] font-semibold'>Meet Our Team</h2>
        
      <div className="c2 c2-sm c1-xs">

        {/* {team.map((categ, index) => ( */}
        {team.slice(0, visibleProfiles).map((categ, index) => (
          <div key={index} className="business-container">
            <img src={categ.image} className="h-[450px]" title="" alt="" />
            <h3 className="text-xl font-semibold">{categ.title}</h3>
            <p className='text-base !leading-[28px]'>{categ.description}</p>
            <Link className="flex items-center text-base" to={`/team/${categ.slug}`}>Read More <UilArrowRight /></Link>
          </div>
        ))}
      </div>

      {visibleProfiles < team.length && (
        <p className="text-center">
          <button onClick={handleLoadMore} className="flex mx-auto w-full justify-center items-center text-center mt-4 text-dark bg-white">
            <b>Load More Profiles</b> <UilArrowDown />
          </button>
        </p>
      )}
    </div>
    </>
  )
}
export default OurTeam;